import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { LuMail, LuMessageCircle } from "react-icons/lu";
import moment from 'moment';
import { getConversationById } from '../../redux/reducers/communicationSlice';

const statusColors = {
  open: { background: 'rgba(16, 185, 129, 0.1)', color: '#10b981' },
  closed: { background: 'rgba(100, 116, 139, 0.1)', color: '#64748b' },
  archived: { background: 'rgba(148, 163, 184, 0.1)', color: '#94a3b8' },
};

const ConversationList = ({ activeId }) => {
  const dispatch = useDispatch();
  const { conversations, loading } = useSelector((state) => state.communication);

  if (loading && conversations.length === 0) {
    return (
      <div className="p-4 text-center text-muted">
        <small>Loading conversations...</small>
      </div>
    );
  }

  if (conversations.length === 0) {
    return (
      <div className="p-4 text-center text-muted">
        <small>No conversations found.</small>
      </div>
    );
  }

  return (
    <div className="conversation-list" style={{ height: 'calc(100vh - 250px)', overflowY: 'auto' }}>
      {conversations.map((conv) => {
        const isActive = activeId === conv._id;
        return (
          <div
            key={conv._id}
            className={`p-3 border-bottom`}
            style={{
              cursor: 'pointer',
              background: isActive ? 'rgba(40,176,196,0.06)' : 'transparent',
              borderLeft: isActive ? '3px solid #28B0C4' : '3px solid transparent',
              transition: 'all 0.15s ease'
            }}
            onClick={() => dispatch(getConversationById(conv._id))}
          >
            <div className="d-flex align-items-start gap-2">
              <div className="rounded-circle d-flex align-items-center justify-content-center flex-shrink-0"
                style={{
                  width: 36, height: 36,
                  background: conv.channel === 'email' ? '#e0f2fe' : '#d1fae5',
                  color: conv.channel === 'email' ? '#0ea5e9' : '#10b981'
                }}>
                {conv.channel === 'email' ? <LuMail size={16} /> : <LuMessageCircle size={16} />}
              </div>

              <div className="flex-grow-1" style={{ minWidth: 0 }}>
                <div className="d-flex justify-content-between align-items-start">
                  <span className="fw-semibold text-dark" style={{ fontSize: '13px' }}>
                    {conv.customerId?.name || 'Unknown Customer'}
                  </span>
                  <span className="text-muted flex-shrink-0" style={{ fontSize: '10px' }}>
                    {moment(conv.lastMessageAt).fromNow()}
                  </span>
                </div>
                <div className="text-muted text-truncate" style={{ fontSize: '12px' }}>
                  {conv.subject || 'WhatsApp conversation'}
                </div>
                <div className="text-muted text-truncate" style={{ fontSize: '11px' }}>
                  {conv.lastMessagePreview}
                </div>
                <div className="d-flex align-items-center gap-1 mt-1">
                  <span className="rounded-pill px-2 fw-semibold"
                    style={{ fontSize: '10px', ...statusColors[conv.status] }}>
                    {conv.status}
                  </span>
                  {conv.unreadCount > 0 && (
                    <span className="rounded-pill px-2 fw-bold"
                      style={{ fontSize: '10px', background: '#28B0C4', color: 'white' }}>
                      {conv.unreadCount} new
                    </span>
                  )}
                </div>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default ConversationList;
